export default __webpack_public_path__ + "static/media/8b1bc6a872bee828.afddcf096d0955728fca58459fe88907.svg";